export default {
  title: 'Propager les modifications ?',
  description: 'Souhaitez-vous propager les modifications à toutes les occurrences de cet article ?',
  submitLabel: 'Modifier les indexations sélectionnées',
  cancelLabel: 'Propager partout'
}
